import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6h16","key":"svg-0"}],["path",{"d":"M6 12h12","key":"svg-1"}],["path",{"d":"M9 18h2","key":"svg-2"}],["path",{"d":"M17 17l-2 2l2 2","key":"svg-3"}],["path",{"d":"M20 21l2 -2l-2 -2","key":"svg-4"}]]

const IconFilter2Code = createReactComponent('outline', 'filter-2-code', 'Filter2Code', __iconNode);

export default IconFilter2Code;